import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';
import { TextSmall } from 'components/chroma/extended';

import { SingleFieldStepProps } from 'scenes/common/types';
import NameQuestion from 'scenes/common/components/Questions/NameQuestion';

const BUSINESS_CONTACT_FIRST_NAME = 'businessContactFirstName';
const BUSINESS_CONTACT_LAST_NAME = 'businessContactLastName';

export const FIRST_NAME_QUESTION = "What is the business contact's first name?";
export const LAST_NAME_QUESTION = "What is the business contact's last name?";

const BusinessContactStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext'> & {
    defaultFirstName: string;
    defaultLastName: string;
  }
> = ({ onNext, defaultFirstName, defaultLastName }) => {
  const { formState: hooksForm, handleSubmit, errors, control } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <NameQuestion
        errors={errors}
        control={control}
        stateKey={BUSINESS_CONTACT_FIRST_NAME}
        defaultValue={defaultFirstName}
        autoCompleteName="given-name"
        question={FIRST_NAME_QUESTION}
      />
      <NameQuestion
        errors={errors}
        control={control}
        stateKey={BUSINESS_CONTACT_LAST_NAME}
        defaultValue={defaultLastName}
        autoCompleteName="family-name"
        question={LAST_NAME_QUESTION}
      />
      <TextSmall>
        The business contact is the individual authorised to make policy changes
        and lodge claims on behalf of the business.
      </TextSmall>
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default BusinessContactStep;
